export function hasRoutePermissions(route, roles = []) {
  return route.matched.every(({ meta }) => {
    const { permissions, requireAllPermissions } = meta;
    if (!Array.isArray(permissions) || permissions.length === 0) return true;

    const hasPermission = (permission) => roles?.includes(permission) === true;
    return requireAllPermissions
      ? permissions.every(hasPermission)
      : permissions.some(hasPermission);
  });
}
